var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpIcoPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_192_17811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 42,
    height: 42,
    transform: "rotate(180 42 42)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_192_17811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.5L13.125 31.5L9.625 31.5L9.625 10.5L13.125 10.5ZM32.375 10.5L32.375 31.5L16.625 21L32.375 10.5Z",
    fill: "#FFBE10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpIcoPrev);
export default __webpack_public_path__ + "static/media/whp-ico-prev.e36c67475118645763b16b07a2cbf887.svg";
export { ForwardRef as ReactComponent };